import * as ng from 'angular';
import {rabbitMQ} from '../../../../third/rabbitMQ';

class WorkerExportArchivePreTdocModalController implements ng.IController {

  static $inject: string[] = [
    '$scope',
    '$rootScope',
    '$uibModal',
    '$state',
    'store',
  ];

  private close: any;

  constructor(
    private $scope: any,
    private $rootScope: any,
    private $uibModal: ng.ui.bootstrap.IModalService,
    private $state: ng.ui.IStateService,
    private store: ng.a0.storage.IStoreService,
  ) {

    $scope.startWorker = (startWorkerLoops) => {
      try {
        if (rabbitMQ.client.STATE === 0) {
          if (startWorkerLoops < 3) {
            setTimeout(() => {
              $scope.startWorker(startWorkerLoops + 1);
            }, 3000);
          } else {

            let modalInstance = $uibModal.open({
              animation: $scope.animationsEnabled,
              component: 'defaultModalComponent',
              windowClass: 'center-modal',
              backdrop: 'static',
              keyboard: false,
              resolve: {
                config: () => {
                  return {
                    headerIcon: 'fa fa-exclamation-triangle',
                    headerText: 'Errore',
                    bodyText: 'Non è stato possibile avviare la comunicazione con il server. N° tentativi ' + startWorkerLoops,
                    buttons: [
                      {
                        'id': 1,
                        'icon': 'fa fa-ban',
                        'label': 'Annulla'
                      },
                      {
                        'id': 2,
                        'icon': 'fa fa-check-circle-o',
                        'label': 'Riprova'
                      }
                    ]
                  };
                }
              }
            });

            modalInstance.result.then((pressedButtonId) => {
              if (pressedButtonId !== undefined) {
                if (pressedButtonId === 1) {
                  this.close();
                }
                if (pressedButtonId === 2) {
                  $scope.startWorker(startWorkerLoops + 1);
                }
              }
            }, (error) => {
              console.error(error);
            });
          }
          return 0;
        }
        $scope.$parent.$resolve.settings.source = 'webApp';
        $scope.$parent.$resolve.settings.requestedBy = store.get('user').accountData.email;
        rabbitMQ.send('worker_export_archive_pre_tdoc' + $rootScope.workerNameSuffix, JSON.stringify($scope.$parent.$resolve.settings));
      } catch (err) {
        $rootScope.alert('error', err.message);
        return 0;
      }
      return 1;
    };

    $scope.workerResponse = $scope.startWorker(0);
    $scope.ok = () => {
      this.close();
    };
  }
}

export const WorkerExportArchivePreTdocModalComponent: ng.IComponentOptions = {
  template: require('./worker-export-archive-pre-tdoc-modal.html'),
  controller: WorkerExportArchivePreTdocModalController,
  bindings: {
    close: '&'
  }
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/admin/worker-export-archive-pre-tdoc-modal/worker-export-archive-pre-tdoc-modal.ts